export default __webpack_public_path__ + "static/media/5.0cb96790.jpg";